import {Route} from 'react-router'
import {Login} from './index'

export const routes = <Route path="/login" element={<Login />} />
